import api from "services/api"

/**
 * Fetch the current user's profile from the backend.
 *
 * @returns {Promise<object>} User profile data.
 */
export const getUserProfile = async () => {
  const response = await api.get("admin/users/profile")
  return response.data
}

/**
 * Update the current user's profile.
 *
 * @param {object} userData - Fields to update (name, phone, …).
 * @returns {Promise<object>}
 */
export const updateProfile = async userData => {
  const response = await api.patch("admin/users/profile", userData)
  return response.data
}

/**
 * Change the current user's password.
 *
 * @param {string} oldPassword
 * @param {string} newPassword
 * @returns {Promise<object>}
 */
export const changePassword = async (oldPassword, newPassword) => {
  const response = await api.patch("auth/reset-password", {
    oldPassword,
    newPassword,
  })
  return response.data
}

/**
 * Retrieve the current user's recent activity log.
 *
 * @returns {Promise<object>}
 */
export const getUserActivity = async () => {
  const response = await api.get("admin/users/activity")
  return response.data
}
